import styled from 'styled-components';

export const Wrapper = styled.header`
  min-height: 60px;
  padding: calc((var(--gap) / 2) - 2px) var(--gap) calc((var(--gap) / 2) + 2px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap);
`;
